export { default } from "./ClassNameGenerator.js";